export enum PlatformType {
	cdc = 0,
	panel = 1,
	cdm = 2,
}
